module.exports = ".checkbox{\r\n  text-align:center;\r\n  align-content:center;\r\n  width:20px;\r\n  height:20px;\r\n}\r\n"